import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import VideoCard from "./videocard";


const BiblePlan = ({ onNext, onCreatePlan, videos = [], onAddPlan }) => {
  const [activeTab, setActiveTab] = useState("Find Plans");
  const [searchText, setSearchText] = useState("");

  const filteredPlans = videos.filter((p) =>
    p.video_title?.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className="flex flex-col">
      {/* Header */}
      <div className="flex justify-between items-center mb-4 gap-2">
   
         <input
          type="text"
          placeholder="Search Video..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="w-full px-4 py-2 rounded-xl bg-[#1a1a1a] text-white border border-gray-600 outline-none"
        />
        <ArrowRight
          onClick={onNext}
          className="text-white w-6 h-6 cursor-pointer"
        />
      </div>


      {/* Category */}
      <div>
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-sm font-semibold text-[#F8BA34]">Select a Video</h2>
          <span className="text-[#F8BA34] text-sm cursor-pointer">{">"}</span>
        </div>

        {/* 2 ROW GRID */}
        <div className="grid grid-flow-col grid-rows-2 gap-4 overflow-x-auto pb-2">
          {filteredPlans.length > 0 ? (
            filteredPlans.map((video, idx) => (
              <VideoCard
                key={idx}
                video={video}
                onAdd={() => onAddPlan(video)}
              />
            ))
          ) : (
            <p className="text-gray-400 text-sm col-span-2">
              No Video found
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default BiblePlan;
